import { render, staticRenderFns } from "./VettingList.vue?vue&type=template&id=9715af2e"
import script from "./VettingList.vue?vue&type=script&lang=js"
export * from "./VettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports